import { VueModule } from '@Foundation/utilities';

import MenuDrawer from './code/Scripts/components/MenuDrawer/MenuDrawer.vue';
import MenuTrigger from './code/Scripts/components/MenuTrigger/MenuTrigger.vue';
import SubmenuDrawer from './code/Scripts/components/SubmenuDrawer/SubmenuDrawer.vue';
import SubmenuTrigger from './code/Scripts/components/SubmenuTrigger/SubmenuTrigger.vue';
import menuStore from './code/Scripts/components/store';

export default VueModule({
  components: {
    MenuDrawer,
    MenuTrigger,
    SubmenuDrawer,
    SubmenuTrigger
  },
  menuStore
});
